const NS = 'EventListingBlock';
const CLS = 'eventListingBlock';

import * as getTemplate from '../../../../global/js/template';
import { spinnerContainerWidgetService } from '../../../../global/js/ara/spinnerContainerWidgetService';
import { alertService } from '../../../../global/js/ara/alertService';
import { paginationjs } from '../../../../global/js/pagination';
import * as Api from '../../../../global/js/api';

export class EventListingBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$pagination = this.$element.find(`.${CLS}-pagination`);
		this.$content = this.$element.find(`.${CLS}-content`);
		this.$list = this.$element.find(`.${CLS}-list`);
		this.$result = this.$element.find(`.${CLS}-result`);
		this.$search = this.$element.find(`.${CLS}-search`);
		this.$searchInput = this.$element.find(`.${CLS}-search-input`);
		this.$select = this.$element.find(`.${CLS}-select`);
		this.$error = this.$element.find(`.${CLS}-error`);
		this.$footer = this.$element.find(`.${CLS}-footer`);
		this.$filter = this.$element.find(`.${CLS}-filterWrap`);

		this.getApi = this.$element.data('api');
		this.pageSize = this.$element.data('pageSize') || 9;

		this.eventTileTemplate = null;
		this.spinnerContainerWidgetService = spinnerContainerWidgetService;
		this.alertService = alertService;

		this.params = {
			"keyword":"",
			"pageNumber": 1,
			"pageSize": this.pageSize,
			"filters":{

			}
		};

		this.getItems();
		this.handlePagination();
		this.handleKeyword();
		// need bind event after render div
		// this.handleFilter();
	}

	handlePagination() {
		this.$element.on('pagination.trigger', () => {
			this.getCurrentFilters();
			this.getItems();
		});
	}
	handleKeyword() {
		// KEYWORD LOGIC 'input'
		this.$searchInput.on('keyup', _.debounce((event) => {
			let keyword = $(event.currentTarget).val().trim();

			if(event.key === 'Enter') {
			} else {
				return;
			}

			if(_.isEmpty(keyword)) {
				// delete this.params.keyword;
				this.params['keyword'] = '';
			}
			else {
				this.params['keyword'] = $(event.currentTarget).val().trim();
			}
			this.params.pageNumber = 1;
			this.params.filters = {};
			this.getItems();
		}, 250));
	}

	// {
	//    "keyword":"test",
	//    "pageNumber":1,
	//    "pageSize":10,
	//    "sort":1,
	//    "filters":{
	//       "searchPublishDate":[
	//          "2018-01-01|2018-12-31",
	//          "2019-07-01|2019-07-30"
	//       ]
	//    }
	// }

	getCurrentFilters() {
		let $labels = $(this.$filter.find('span.badge'));
		this.params.filters = {};

		for (let i = 0; i < $labels.length; i++) {
			let $label = $($labels[i]);
			let groupkey = $label.data('groupkey');
			let key = $label.data('key');
			let bool = $label.hasClass('true');

			if(!this.params.filters[groupkey] || this.params.filters[groupkey] === undefined) {
				if(bool) {
					this.params.filters[groupkey] = [key];
				}
			} else {
				if(bool) {
					if(!this.params.filters[groupkey].includes(key)) {
						this.params.filters[groupkey].push(key);
					}
				}
			}
		}
	}

	handleFilter() {
		this.$filter.find(`span`).on('click', (e) => {
			$(e.currentTarget).toggleClass('true false')

			this.getCurrentFilters();
			console.log(this.params.filters, typeof this.params.filters);
			this.params.pageNumber = 1;
			this.getItems();
		});
	}

	getItems() {
		let url = this.getApi;
		if(!url) {
			console.error(`${NS}::Error - getItems. Please provide api-url on 'data-api'.`);
			return;
		}

		this.$error.html('');
		this.spinnerContainerWidgetService.create(this.$content);

		Api.callApi(url, this.params).then((data) => {
			console.log(data);
			// internal server error
			// {"successful":false,"failureMessage":"Failed to perform search: Value cannot be null.\r\nParameter name: source","data":null}
			if(data.successful == false) {
				this.$list.html(this.alertService.getPrimaryMarkup(`Sorry, Failed to perform search.`));
				this.$footer.removeClass('hasResults');
				this.$result.html(null);
				this.spinnerContainerWidgetService.destroy();
				return;
			}

			if(data.data) {
				let items = data.data.results;
				let filters = data.data.facets;

				if(items.length === 0) {
					this.$list.html(this.alertService.getPrimaryMarkup(`Sorry, no articles found.`));
					this.$footer.removeClass('hasResults');
					this.$result.html(null);
					this.spinnerContainerWidgetService.destroy();
					return;
				}

				let tmpl = '';
				let filterTmpl = '';

				if(!this.eventTileTemplate) {
					this.eventTileTemplate = getTemplate.eventTileBlock();
				}

				if(!this.filterTemplate) {
					this.filterTemplate = getTemplate.filterTemplate();
				}
				// render the filter
				_.forEach(filters, (filter) => {
					console.log(filter);
					filterTmpl += `
						${this.filterTemplate(filter)}
					`;
				});
				this.$filter.html(`${filterTmpl}`);
				this.handleFilter();

				// render article cell
				_.forEach(items, (item) => {
					tmpl += `
					<div class="${CLS}-item col-12 col-md-6 col-lg-4">
						${this.eventTileTemplate(item)}
					</div>
					`;
				});
				this.$list.html(`<div class="row">${tmpl}</div>`);

				this.$footer.addClass('hasResults');

				// render total result
				this.setResultText(data.data.pageNumber, data.data.totalCount);

				// render pagination
				paginationjs(this.pageSize, data.data.totalCount, this.$pagination, this);
				this.spinnerContainerWidgetService.destroy();
			}
		}).catch((error) => {
			console.log(error);
		});
	}

	setResultText(pageNumber, totalCount) {
		let start = (pageNumber - 1) * this.pageSize || 1;
		let end = this.pageSize > totalCount ? totalCount : pageNumber * this.pageSize;
		console.log(end, this.pageSize, totalCount);

		this.$result.html(`Showing ${start}-${end} of ${totalCount} results`);
	}
}
